import { IndustrialCodeValue } from './industrial-code-value';

export class IndustrialCodeType {
  codeTypeId: number;
  name: string;
  subtypes?: IndustrialCodeValue[];
}
